import type { DisciplineSchedule } from '@brighterly/lib-core-types/discipline/interfaces'
import type { ProgressReportStore } from '../model/store/interfaces'

import { isFullArray } from '@shared/lib/collections'

import { getReport } from './report'

const getSchedule = (state: ProgressReportStore): DisciplineSchedule | null => getReport(state)?.schedule || null

export const schedule = {
  getSchedule: (state: ProgressReportStore): DisciplineSchedule | null => getSchedule(state),
  hasSchedule: (state: ProgressReportStore): boolean => isFullArray(getSchedule(state)?.days || []),
}
